<template>
  <div v-if="reloadControl" class="custom-select">
    <label :for="'seld' + timeStamp" class="sr-only">Select</label>
    <el-select
      :id="'seld' + timeStamp"
      v-model="seld"
      :popper-class="popperClass"
      :class="{ red: isRed }"
      :disabled="disabled"
      :placeholder="placeHolder"
      :popper-append-to-body="isAppendToBody"
      placement="bottom"
      @visible-change="visibleChange"
      @click="$emit('sd-click')"
    >
      <el-option
        v-for="(item, index) in standardOptions"
        :key="index"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'SelectUnderline',
  model: {
    prop: 'modelValue',
    // event: 'returnBack',
    event: 'change',
  },
  props: {
    popperClass: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeHolder: {
      type: String,
      default: '',
    },
    isAppendToBody: {
      type: Boolean,
      default: true,
    },
    /* 颜色是否变为红色提示色 */
    isRed: {
      type: Boolean,
      default: false,
    },
  },
  emits: { change: null, 'update:modelValue': null, 'sd-click': null },
  data() {
    return {
      seld: '',
      reloadControl: true,
      timeStamp: new Date().valueOf(),
    };
  },
  computed: {
    // standardOptions() {
    //   return this.options.length
    //     ? typeof this.options[0] === 'object'
    //       ? this.options
    //       : this.options.map((item, index) => {
    //           return {
    //             label: item,
    //             value: item,
    //           };
    //         })
    //     : [];
    // },
    standardOptions() {
      let result = [];

      if (this.options.length > 0) {
        if (typeof this.options[0] === 'object') {
          // 如果 options 的第一个元素已经是对象，则直接返回 options
          result = this.options;
        } else {
          // 如果 options 的元素不是对象，将其转换为具有 label 和 value 的对象数组
          result = this.options.map((item, index) => {
            return {
              label: item,
              value: item,
            };
          });
        }
      }
      return result;
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newV, oldV) {
        if (newV === this.seld) return;
        this.seld = newV;
      },
    },
    seld: {
      immediate: false,
      handler(newV, oldV) {
        if (newV === this.value) {
          return;
        }
        // this.value = newV
        // this.$emit('returnBack', newV)
        this.$emit('update:modelValue', newV);
        this.$emit('change', newV);
      },
    },
    options: {
      immediate: false,
      deep: true,
      handler(newV, oldV) {
        this.reload();
      },
    },
  },
  methods: {
    visibleChange(flag) {
      if (flag) {
        setTimeout(() => {
          const selectDom = document.querySelector(
            `.${this.popperClass} .el-select-dropdown__item.selected`,
          );
          selectDom && selectDom.scrollIntoView({ block: 'center' });
        }, 100);
      }
    },
    reload() {
      this.reloadControl = false;
      this.$nextTick(() => {
        this.reloadControl = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-select {
  width: 100%;
  height: 100%;
  :deep(.el-select) {
    position: relative;
    width: 100%;
    height: 100% !important;
    &.red {
      :deep(.el-input) {
        input {
          color: $origin !important;
        }
      }
    }
    .el-input {
      height: 100% !important;
      &.is-focus .el-input__wrapper {
        box-shadow: none;
      }
      .el-input__wrapper {
        padding-right: 10px;
        padding-left: 8px;
        height: calc(100% - 1px) !important;
        line-height: 28px;
        border: none !important;
        border-bottom: 2px solid #dcdcdc !important;
        border-radius: 1px;
        box-shadow: none;
        &:hover {
          border-bottom: 2px solid $origin !important;
        }
        &:focus {
          border-bottom: 2px solid $origin !important;
        }
      }
      .el-input__suffix {
        right: -4px;
        top: -3px;
        i {
          color: #908b7f;
        }
      }
      .is-focus .el-input__wrapper {
        box-shadow: none;
      }
    }
    .is-disabled {
      .el-input__wrapper {
        color: #cccccc;
        background: white !important;
        &:hover {
          border-bottom: 2px solid #dcdcdc !important;
        }
        &:focus {
          border-bottom: 2px solid #dcdcdc !important;
        }
      }
      .el-input__inner {
        background-color: #ffffff;
      }
      .el-input__suffix {
        i {
          color: #cccccc;
        }
      }
    }
  }
}
</style>
